import { createSlice } from '@reduxjs/toolkit';
import { MetaType } from 'types';
import { EncounterAnalytic } from '../../../types/encounterManagement';

interface EncounterAnalyticState {
  meta: MetaType;
  encounterAnalytics: EncounterAnalytic[];
}

const initialState: EncounterAnalyticState = {
  meta: <MetaType>{},
  encounterAnalytics: []
};

const encouterAnalyticSlice = createSlice({
  name: 'encounterAnalytic',
  initialState,
  reducers: {
    setAllEncounterAnalytic(state, action) {
      state.encounterAnalytics = action.payload.results || [];
      state.meta = action.payload.meta || <MetaType>{};
    },

    setOneEncounterAnalytic(state, action) {
      state.encounterAnalytics = state.encounterAnalytics.map(item => {
        if (item.id !== action.payload.id) return item;
        else return { ...item, ...action.payload.row };
      });
    }
  }
});

export const { setAllEncounterAnalytic, setOneEncounterAnalytic } =
  encouterAnalyticSlice.actions;
export default encouterAnalyticSlice.reducer;
